import React from "react";
import Layout from "../../components/layout";
import ConciliacionCalendarUploadedFiles from "../../components/conciliacionCalendarUploadedFiles";

interface Props {}
interface State {}

/**
 * Contenedor principal del calendario de cargos; para determinar los días de
 * transacciones entre tipos de tarjetas (TDD, TDC, AMEX)
 */
export class ConciliacionCalendarUploadedFilesPage extends React.Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <ConciliacionCalendarUploadedFiles />
        </Layout>
      </main>
    );
  }
}
